var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"height":"inherit"}},[(_vm.formatData)?_c('div',{staticClass:"chart-scatter"},[_c('div',{ref:"canvas",staticClass:"canvas"})]):_c('div',{staticClass:"chart-scatter no-data"},[_vm._v("散点图-暂无数据")])])
}
var staticRenderFns = []

export { render, staticRenderFns }